/**
 * Servicio de OCR para extraer texto de imágenes de recibos/tickets.
 */
import Tesseract from "tesseract.js";
import { parseReceiptAmount, parseReceiptAmountCandidates, parseReceiptCurrency } from "../utils/receiptParser";
import { scaleImageForOcr } from "../utils/imagePreprocess";

/**
 * Extrae texto de una imagen usando OCR.
 * Preprocesa la imagen (escala 2x) para mejorar precisión en recibos.
 */
export async function extractTextFromImage(imageSource, onProgress) {
  let processedSource = imageSource;
  if (imageSource instanceof File || imageSource instanceof Blob) {
    try {
      processedSource = await scaleImageForOcr(imageSource);
    } catch {
      processedSource = imageSource;
    }
  }

  const { createWorker, PSM } = Tesseract;
  const worker = await createWorker("spa+eng", 1, {
    logger: (m) => {
      if (onProgress && m.status === "recognizing text" && m.progress) {
        onProgress(Math.round(m.progress * 100));
      }
    }
  });
  try {
    await worker.setParameters({ tessedit_pageseg_mode: PSM.SINGLE_COLUMN });
    const { data } = await worker.recognize(processedSource);
    return data.text;
  } finally {
    await worker.terminate();
  }
}

/**
 * Extrae monto, candidatos y moneda de un recibo desde una imagen.
 */
export async function extractAmountFromReceipt(imageSource, onProgress) {
  const rawText = await extractTextFromImage(imageSource, onProgress);
  const amount = parseReceiptAmount(rawText);
  const amountCandidates = parseReceiptAmountCandidates(rawText);
  const currency = parseReceiptCurrency(rawText);
  return { amount, amountCandidates, currency, rawText };
}
